import { Theme } from "../../../components/constants";

export default {
    headerContainer: {
        display: "flex",
        alignItems: "center",
        marginBottom: "40px"
    },

    headerText: {
        display: "flex",
        alignItems: "center",
        columnGap: "10px"
    },

    gridContainer: {
        marginTop: "0px"
    },

    dropdownContainer: {
        display: "flex",
        columnGap: "20px",
        justifyContent: "space-between"
    },

    selectDropdown: {
        display: "flex",
        columnGap: "20px",
    },

    buttonContainer: {
        display: "flex",
        flexWrap: "wrap",
        margin: "20px 0 20px",
        alignItems: "center",
        rowGap: "10px"
    },

    button: {
        padding: "6px 22px",
    },

    actionButtons: {
        display: "flex",
        columnGap: "10px",
        alignItems: "center",
        justifyContent: "center"
    },

    flexColumnWithGap: {
        display: "flex",
        flexDirection: "column",
        gap: "5px",
    },
    actionButtonContainer: {
        display: "flex",
        alignItems: 'center',
        marginLeft: "5px",
        columnGap: "5px",
        flexWrap: "wrap",
        rowGap: "10px"
    },
    bulkActionDropdown: {
        border: "1px solid #215DAA",
        borderRadius: "80px",
        padding: "6px 22px",
        height: "fit-content",
        background: `${Theme.PRIMARY}`
    },
    bulkActionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        left: "-20px",
        top: "29px",
    },
    bulkActionDropdownLabel: {
        marginRight: "16px",
        fontSize: "16px",
        color: `${Theme.TEXT_WHITE}`,
        fontWeight: "700"
    },

    moreActionDropdown: {
        background: "#F8FAFB",
        border: "1px solid #215DAA",
        borderRadius: "80px",
        padding: "6px 22px",
        height: "fit-content",
        marginLeft:"5px"
    },

    moreActionDropdownLabel: {
        marginRight: "16px",
        fontSize: "16px",
        color: `${Theme.TEXT_PRIMARY}`
    },
    moreActionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        left: "-125px",
        top: "29px",
    },
    menuItemsDropdown: {
        width: "max-content",
        minWidth: "auto",
        top: "15px",
        left: "-40px",
    },
    disabledMenuItem: {
        color: `${Theme.DISABLED_TEXT}`,
        cursor: "not-allowed",
    },
    prmiaryText: {
        color: `${Theme.TEXT_PRIMARY}`
    },
    errorPopupBodyContainer: {
        flexWrap: "wrap"
    },
    downloadErrorsBtnContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    buttonBackgroundWIcon: {
        background: "none",
    }
}